<template>
  <v-container class="d-flex justify-center">
    <v-card flat>
      <h4>SIDAN HITTADES INTE</h4>
      <div class="mt-5 mb-5 d-flex justify-center">
        <v-icon class="link-broken">$sl-unlink</v-icon>
      </div>

      <p>
        <b>Sidan du försökte komma till verkar inte finnas längre.</b>
      </p>
      <p>Du kan gå tillbaka till startsidan genom att trycka på knappen nedan.</p>

      <v-btn color="primary" class="mt-6" @click="$router.push('/')">
        <v-icon>$sl-arrow-left</v-icon>startsidan
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
// @group Common
// NotFound component
import {mapGetters} from 'vuex'

export default {
  name: 'NotFound',
  
  computed: {    
    ...mapGetters('currentuser', ['currentUser','isLoggedIn'])
  },
}
</script>

<style scoped>
.link-broken {
  width: 192px;
  height: 192px;
}
</style>